<app-header></app-header>
<div class="breadcrumb">
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <span><a class="cursor-link" (click)="goToTheme()">Preview</a> > Education > Experience > Skills > Languages > Hobbies > Accomplishments > Certificates > About Me > <strong>Others</strong></span>
      </div>
    </div>
  </div>
</div>
<div class="addOthers">
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <h2>{{optionalField.name}}</h2>
      </div>
      <div class="col-sm-6">
        <div class="form-group">
          <input [(ngModel)]="optionalField.name" type="text" class="form-control"placeholder="Section Title" required>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6">
        <div class="tinyMCE">
          <editor [init]="utilService.editorConfig" [(ngModel)]="optionalField.value"></editor>
        </div>
      </div>
      <div class="col-sm-6">
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6">
        <div class="addOthers__buttons">
          <button class="btn btn-default" routerLink="/resume/summary">Back</button>
        </div>
      </div>
      <div class="col-sm-6 text-right">
        <div class="addOthers__buttons">
          <button class="btn btn-primary" (click)="addNext()" [hidden]="optionalField.id">Add And Next</button>
          <button class="btn btn-primary" (click)="editNext()" *ngIf="optionalField.id">Save And Next</button>
        </div>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>
